<template>
  <v-card tile flat class="mt-0 pt-0">
    <v-card-text class="ma-0 py-0">
      <v-form autocomplete="off">
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-autocomplete
              clearable
              outlined
              dense
              autocomplete="off"
              autofocus
              name="Tahap"
              :items="itemDiklats"
              placeholder="Semua Tahap"
              label="Pilih Tahap"
              @change="$emit('filter', filtered)"
              v-model="filtered.jenis"
              data-vv-name="jenis"
              data-vv-as="Tahap"
              item-text="nama"
              item-value="id"
              hide-details
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
  </v-card>
</template>
<script>
// @group Global Filter Data
export default {
  props: {
    masters: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialog: true,
      filtered: {
        tingkat: null,
        mapel: null,
        status: null
      },
      itemDiklats: []
    };
  },
  mounted() {
    this.loadDiklat();
  },
  methods: {
    // eslint-disable-next-line
    loadDiklat() {
      return this.$store
        .dispatch("diklat/get", {
          instansi_id: this.instansi_id
        })
        .then(res => {
          return (this.itemDiklats = res.data);
        })
        .catch(e => e);
    }
  }
};
</script>
